module.exports = __webpack_public_path__ + "img/multiplier_8_th.8fcdd597.png";